/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_2_AInputs */

const en_mk_faq_2_a = /** @type {(inputs: Mk_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free includes an initial allowance for planning and agent chat. See the pricing section for current limits. Automatic building, your own AI service, guided support, and hosting follow their own terms; free to start does not mean every part of the process is free.`)
};

const id_mk_faq_2_a = /** @type {(inputs: Mk_Faq_2_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket Free menyediakan kuota awal untuk perencanaan dan chat agent. Lihat angka terbaru di bagian harga. Biaya membangun otomatis, layanan AI sendiri, pendampingan, dan hosting mengikuti ketentuannya masing-masing; gratis mulai bukan berarti seluruh proses tanpa biaya.`)
};

/**
* | output |
* | --- |
* | "Free includes an initial allowance for planning and agent chat. See the pricing section for current limits. Automatic building, your own AI service, guided s..." |
*
* @param {Mk_Faq_2_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_2_a = /** @type {((inputs?: Mk_Faq_2_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_2_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_2_a(inputs)
	return en_mk_faq_2_a(inputs)
});